import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import theme from './theme';
import { AppProvider } from './hooks/useApp';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import ToastNotification from './components/ui/ToastNotification';
import HomePage from './pages/HomePage';
import VideosPage from './pages/VideosPage';
import ArticlesPage from './pages/ArticlesPage';
import ArticleDetailPage from './pages/ArticleDetailPage';
import DealsPage from './pages/DealsPage';
import AdminPage from './pages/AdminPage';
import DocumentsPage from './pages/DocumentsPage';

function Layout({ children, showFooter = true }) {
  return (
    <>
      <Navbar />
      {children}
      {showFooter && <Footer />}
      <ToastNotification />
    </>
  );
}

export default function App() {
  return (
    <ChakraProvider theme={theme}>
      <ColorModeScript initialColorMode="dark" />
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout><HomePage /></Layout>} />
            <Route path="/videos" element={<Layout><VideosPage /></Layout>} />
            <Route path="/articles" element={<Layout><ArticlesPage /></Layout>} />
            <Route path="/articles/:id" element={<Layout><ArticleDetailPage /></Layout>} />
            <Route path="/deals" element={<Layout><DealsPage /></Layout>} />
            <Route path="/docs" element={<Layout><DocumentsPage /></Layout>} />
            <Route path="/admin" element={<Layout showFooter={false}><AdminPage /></Layout>} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </ChakraProvider>
  );
}
